var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FloatingPanel',[_c('div',{staticClass:"common-canvas-blocks-common-leftImageRightText-BlockPanel"},[_c('CommonInputs',{attrs:{"options":_vm.options}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }